import { StatusWrapper } from '@/components/StatusWrapper/StatusWrapper';
import { VaultAccountStatusType } from '@/types/myVaultTypes';
import { VAULT_ACCOUNT_STATUS_MAP, VAULT_ACCOUNT_STATUS_TEXT } from '../const/const';

export const VaultAccountStatus = ({ status }: { status: VaultAccountStatusType }) => {
  return (
    <StatusWrapper variant={VAULT_ACCOUNT_STATUS_MAP[status]?.variant}>
      {VAULT_ACCOUNT_STATUS_MAP[status]?.statusIcon}
      {VAULT_ACCOUNT_STATUS_TEXT[status] || '-'}
    </StatusWrapper>
  );
};
